// monitorEntries — one chronological list for the "Zadania w tle" monitor.
// Actions (ActionContext step ladders) and processes (ProcessContext batches)
// share one drawer; this merges them oldest first. Pure.
import type { Action } from "@ds/actions/useActions";
import type { Process } from "@ds/actions/useProcesses";

export type MonitorEntry =
  | { kind: "action"; key: string; createdAt: Date; action: Action }
  | { kind: "process"; key: string; createdAt: Date; process: Process };

/** Oldest first; equal timestamps keep input order with actions before processes (stable sort). */
export function mergeMonitorEntries(actions: Action[], processes: Process[]): MonitorEntry[] {
  const entries: MonitorEntry[] = [
    ...actions.map((action) => ({ kind: "action" as const, key: `action:${action.id}`, createdAt: action.createdAt, action })),
    ...processes.map((process) => ({ kind: "process" as const, key: `process:${process.id}`, createdAt: process.createdAt, process })),
  ];
  return entries.sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());
}
